<template>
    <div>
        <el-dialog title="编辑电子运单" :visible.sync="vis" width="80%" top="5vh" >
            <el-form inline label-width="100px" :model="eWaybill" class="demo-ruleForm">
                <el-divider >原始业务信息</el-divider>
                <el-form-item label="业务单号" required  >
                    <el-input v-model="eWaybill.businessNo" style="width: 300px" placeholder="业务单号(必填)" />
                </el-form-item>
                <el-form-item label="货品名称"  >
                    <el-input v-model="eWaybill.productName" style="width: 200px"  />
                </el-form-item>
                <el-form-item label="货品数量"   >
                    <el-input-number v-model="eWaybill.productQuantity" style="width: 200px" />
                </el-form-item><br/>
                <el-form-item label="运单备注"  >
                    <el-input type="textarea" v-model="eWaybill.remark" style="width: 600px" />
                </el-form-item>

                <el-divider>发货信息</el-divider>
                <!-- <el-form-item label="发货客户" >
                    <plt-biz-select v-model="eWaybill.fromMemberId" url="CORE-MEMBER/messageService/memberCustomerService/queryCustomerByMemberId" 
                        :params="{memberId, roleId: 'MEMBER_CUSTOMER'}" codeField="id" textField="name" style="width:300px" />
                </el-form-item> -->
                <el-form-item >
                    <el-button type="primary" plain @click="openContactDL('from')" >选择发货联系人</el-button>
                </el-form-item>
                <br/>
                <el-form-item label="联系人" >
                    <el-input v-model="fromContact.name" style="width: 200px" />
                </el-form-item>
                <el-form-item label="手机号" >
                    <el-input v-model="fromContact.phoneNumber" style="width: 200px" />
                </el-form-item>
                <el-form-item label="区域" >
                    <plt-address-cascader v-model="fromContact.areaId" width="300" />
                </el-form-item>
                <el-form-item label="详细地址" >
                    <el-input type="textarea" v-model="fromContact.detailAddress" style="width: 300px" />
                </el-form-item>

                <el-divider >收货信息</el-divider>
                <el-form-item label="收货客户" >
                    <plt-biz-select v-model="eWaybill.toMemberId" url="CORE-MEMBER/messageService/memberCustomerService/queryCustomerByMemberId" 
                        :params="{memberId, roleId: 'MEMBER_CUSTOMER'}" codeField="id" textField="name" style="width:300px" />
                </el-form-item>
                <el-button type="primary" plain @click="openContactDL('to')" >选择联系人</el-button>
                <br/>
                <el-form-item label="联系人" >
                    <el-input v-model="toContact.name" style="width: 200px" />
                </el-form-item>
                <el-form-item label="手机号" >
                    <el-input v-model="toContact.phoneNumber" style="width: 200px" />
                </el-form-item>
                <el-form-item label="区域" >
                    <plt-address-cascader v-model="toContact.areaId" width="300" />
                </el-form-item>
                <el-form-item label="详细地址" >
                    <el-input type="textarea" v-model="toContact.detailAddress" style="width: 300px" />
                </el-form-item>
                <el-divider >物流信息</el-divider>

                <el-form-item label="物流公司" >
                    <plt-biz-select v-model="eWaybill.logisticMemberId" url="CORE-MEMBER/messageService/memberCustomerService/queryCustomerByMemberId" 
                        :params="{memberId, roleId: 'MEMBER_LOGISTICS'}" codeField="id" textField="name" style="width:300px" />
                </el-form-item>
                <el-button type="primary" plain @click="openDriverDL" >选择司机</el-button>
                <br/>                
                <el-form-item label="司机" >
                    <el-input v-model="driver.name" style="width: 200px" />
                </el-form-item>
                <el-form-item label="手机号" >
                    <el-input v-model="driver.phoneNumber" style="width: 200px" />
                </el-form-item>                
                <el-form-item label="车牌号" >
                    <el-input v-model="driver.plateNumber" style="width: 300px" />
                </el-form-item>

            </el-form>    
            <div slot="footer" class="dialog-footer">
                <el-button @click="vis = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>            
        </el-dialog>
        
        <el-dialog title="选择联系人" :visible.sync="vis_ct" width="80%" >
           <plt-table v-if="vis_ct" url="CORE-MEMBER/messageService/memberCustomerService/queryContactWaysByMemberId" 
                :queryParams="contactWayQueryParam" :pagination="false"  >

                <template #table="{data, pageSize, pageNum}"  >
                    <el-table :data="data" border size="mini" >
                        <el-table-column label="#" width="40" align="center" type="index" :index="(index) => index + pageSize * (pageNum - 1) + 1" />
                        <el-table-column prop="name" label="联系人名称" width="200" />
                        <el-table-column prop="mobile" label="手机号" width="150" />
                        <plt-table-dict-col prop="areaId" label="省市区" width="200" namespace="region" id="fullArea" />
                        <el-table-column prop="address" label="详细地址" width="150" />
                        <el-table-column prop="action" label="选择" width="100" >
                            <template #default="{ row }" >
                                <el-button type="primary" @click="pickContact(row)" size="mini" >选 择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </plt-table>        
        </el-dialog>

        <el-dialog title="选择司机" :visible.sync="vis_dv" width="80%" >
            <plt-table v-if="vis_dv" url="CORE-MEMBER/messageService/memberCustomerService/queryDriversByMemberId" 
                :queryParams="contactWayQueryParam" :pagination="false"  >

                <template #table="{data, pageSize, pageNum}"  >
                    <el-table :data="data" border size="mini" >
                        <el-table-column label="#" width="40" align="center" type="index" :index="(index) => index + pageSize * (pageNum - 1) + 1" />
                        <el-table-column prop="name" label="联系人名称" width="200" />
                        <el-table-column prop="mobile" label="手机号" width="150" />
                        <el-table-column prop="plateNo" label="车牌号" width="150" />
                        <el-table-column prop="action" label="选择" width="100" >
                            <template #default="{ row }" >
                                <el-button type="primary" @click="pickDriver(row)" size="mini" >选 择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </plt-table>
        </el-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            memberId: '',

            eWaybill: {
                masterMemberId: '',
                toMemberId: '',
                fromMemberId: '',
                logisticMemberId: '',
                businessNo: '',
                remark: ''
            },
            contactWayQueryParam: {
                memberId: ''
            },
            fromContact: {
                name: '',
                phoneNumber: '',
                areaId: '',
                detailAddress: '',
            },
            toContact: {
                name: '',
                phoneNumber: '',
                areaId: '',
                detailAddress: '',
            },
            driver: {
                name: '',
                phoneNumber: '',
                plateNumber: ''
            },
            vis: false,
            vis_ct: false,
            vis_dv: false,
            contactType: ''
        }
    },
    created() {
        this.memberId = sessionStorage.getItem("memberId");
    },       
    mounted() {
    },
    methods: {
        openDialog() {
            this.vis = true;
            
            this.pltUtil.resetObj(this.eWaybill)
            this.pltUtil.resetObj(this.fromContact)
            this.pltUtil.resetObj(this.toContact)
            this.pltUtil.resetObj(this.driver)

            this.eWaybill.businessNo = this.generateWaybillId()
            this.eWaybill.fromMemberId = sessionStorage.getItem('memberId')
        },
        generateWaybillId() {
            return `${sessionStorage.getItem('memberId')}_${new Date().Format('yyyyMMddhhmmss')}`
        },
        submit() {
            
            if(!this.eWaybill.businessNo)
                return this.$message({type: 'error', message: '业务单号必填!'});

            let url = "MID-OPERATE-LOGISTICS/messageService/eWaybillService/editEWayBill";

            this.eWaybill.masterMemberId = this.memberId;
            let param = {
                eWaybill: this.eWaybill,
                fromContact: this.fromContact,
                toContact: this.toContact,
                driverContact: this.driver
            }

            this.cfmInvoke(url, param).then(() => {
                this.vis = false;
                this.$notify({type: 'success', message: '操作成功'});
                this.$emit('on-edit-success');
            })
        },
        openContactDL(type) {
            
            this.contactType = type;
            this.contactWayQueryParam.memberId = type == 'from' ? this.eWaybill.fromMemberId : this.eWaybill.toMemberId;
            this.notBlank(this.contactWayQueryParam.memberId, '请先选择收发货公司');

            this.vis_ct = true;
        },
        pickContact(row) {
            let contact = this.contactType == 'from' ? this.fromContact : this.toContact;

            contact.name = row.name;
            contact.phoneNumber = row.mobile;
            contact.areaId = row.areaId;
            contact.detailAddress = row.address;
            this.vis_ct = false
            this.contactType = '';
        },
        openDriverDL() {

            this.notBlank(this.eWaybill.logisticMemberId, '请先选择收物流公司');

            this.contactWayQueryParam.memberId = this.eWaybill.logisticMemberId;
            this.vis_dv = true;
        },
        pickDriver(row) {
            this.driver.name = row.name;
            this.driver.phoneNumber = row.mobile;
            this.driver.plateNumber = row.plateNo;
            this.vis_dv = false;
        }
    }
}
</script>
